import React from "react";
import { Div } from "atomize";
import { graphql } from "gatsby";
import Header from "../components/common/Header";

import SEO from "../components/seo";
import Layout from "../components/common/layout";
import Footer from "../components/common/Footer";
import ReviewModule from "../components/common/ReviewModule";
import CampaignSuiteHero from "../components/campaignsuite/CamaignSuiteHero";
import CampaignPoints from "../components/campaignsuite/CampaignPoints";
import CampaingBuilder from "../components/campaignsuite/CampaingBuilder";
import CampaignTestimonial from "../components/campaignsuite/CampaignTestimonial";
import CampaignPhone from "../components/campaignsuite/CampaignPhone";
import CampaignShipping from "../components/campaignsuite/CampaignShipping";
import SolutionsLearnMore from "../components/common/SolutionsLearnMore";
import CampaignBranded from "../components/campaignsuite/CampaignBranded";
import SolutionsDashboard from "../components/common/SolutionsDashboard";
import SolutionsFooter from "../components/common/SolutionsFooter";

const CampaignSuite = ({ data }) => {
  const content = JSON.parse(data.contentfulJson.json.json);

  return (
    <Layout>
      <SEO
        seo={data.contentfulJson.seo}
        url="https://trend.io/campaign-management-suite"
      />

      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <CampaignSuiteHero
        content={content.hero}
        form={
          data.contentfulGlobalConfig.campaignManagementForm1
            .campaignManagementForm1
        }
      />
      <CampaignPoints content={content.campaignPoints} />
      <CampaingBuilder
        content={content.campaignBuilder}
        form={
          data.contentfulGlobalConfig.campaignManagementForm2
            .campaignManagementForm2
        }
      />
      <CampaignTestimonial content={content.campaignTestimonial} />
      <CampaignPhone content={content.campaignPhone} />
      <CampaignShipping content={content.campaignShipping} />
      <Div m={{ t: "6rem" }}>
        <ReviewModule content={content.reviewModule} />
      </Div>
      <Div m={{ t: "8.7rem" }}>
        <SolutionsLearnMore
          content={content.LearnMoreContent}
          form={
            data.contentfulGlobalConfig.campaignManagementForm3
              .campaignManagementForm3
          }
        />
      </Div>
      <CampaignBranded content={content.campaignBranded} />
      <Div m={{ t: { xs: "8.5rem", md: "13.375rem" } }}>
        <SolutionsDashboard content={content.dashboard} />
      </Div>
      <Div m={{ t: "5rem" }}>
        <SolutionsFooter content={content.footerContent} />
      </Div>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export const query = graphql`
  query SolutionPage2 {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    contentfulJson(contentful_id: { eq: "185CJkrpWLlQk4G5749bOz" }) {
      json {
        json
      }

      seo {
        ...SeoFragment
      }
    }

    contentfulGlobalConfig {
      campaignManagementForm1 {
        campaignManagementForm1
      }
    }

    contentfulGlobalConfig {
      campaignManagementForm2 {
        campaignManagementForm2
      }
    }

    contentfulGlobalConfig {
      campaignManagementForm3 {
        campaignManagementForm3
      }
    }
  }
`;

export default CampaignSuite;
